import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import LandingPage from './pages/LandingPage';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import NewsletterPopup from './components/NewsletterPopup';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import About from './components/About';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/success/:sessionId" element={<SubscriptionSuccess />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <NewsletterPopup />
      </div>
    </Router>
  );
}

export default App;
